import {
  ItemDetailsDto,
  ItemDetailsSidebarSectionResp,
} from '@marketplace-web/domain/item-page-data'

export const getItemPageClosetCountdownActionPluginModel = (itemDto: ItemDetailsDto) => {
  const endDate = itemDto.user.closet_countdown_end_date

  if (!endDate) return undefined

  return {
    userId: itemDto.user.id,
    endDate,
    ownerLogin: itemDto.user.login,
    isFollowed: itemDto.user.is_favourite,
    isHatePresent: itemDto.user.is_hated || itemDto.user.hates_you,
    itemId: itemDto.id.toString(),
    canBuy: itemDto.can_buy,
    canInstantBuy: itemDto.instant_buy,
    isReserved: itemDto.is_reserved,
    isHidden: itemDto.is_hidden,
    reservedForUserId: itemDto.reservation?.to_whom_id,
  }
}

export const getServerItemPageClosetCountdownActionPluginModel = (
  sidebarDto: ItemDetailsSidebarSectionResp,
) => {
  const endDate = sidebarDto.closet_countdown_end_date

  if (!endDate) return undefined

  return {
    userId: sidebarDto.seller_id,
    endDate,
    ownerLogin: sidebarDto.login,
    isFollowed: sidebarDto.is_favourite,
    isHatePresent: sidebarDto.is_hated || sidebarDto.hates_you,
    itemId: sidebarDto.id.toString(),
    canBuy: sidebarDto.can_buy,
    canInstantBuy: sidebarDto.instant_buy,
    isReserved: sidebarDto.is_reserved,
    isHidden: sidebarDto.is_hidden,
    reservedForUserId: sidebarDto.reservation?.to_whom_id,
  }
}
